import { IUserModel } from "../../models/user/user.model";
import { PhoneNumberUtil } from "../../utils/phone-number.util";
import { IUser } from "../user/user";
import { IUserTableRow } from "../user/user-table-row";
import { GroupConverter } from "./group.converter";

export class UserConverter {
  public static toModel(user: IUser): IUserModel {
    return {
      active: user.active,
      deliveryEmail: user.deliveryEmail,
      firstName: user.firstName,
      fullName: user.fullName,
      lastName: user.lastName,
      group: user.group ? GroupConverter.toModel(user.group) : undefined,
      email: user.email,
      username: user.username,
      language: user.language,
      telephone: PhoneNumberUtil.transformPhoneNumber(user.telephone),
      title: user.title,
      externalId: user.externalId ?? "-",
      jobTitle: user.jobTitle ?? "-",
      notify: user.notify,
      rolePom: user.rolePom,
    };
  }

  public static toDomain(user: IUserModel): IUser {
    return {
      active: user.active,
      deliveryEmail: user.deliveryEmail,
      firstName: user.firstName,
      fullName: user.fullName,
      lastName: user.lastName,
      group: user.group ? GroupConverter.toDomain(user.group) : undefined,
      email: user.email,
      username: user.username,
      language: user.language,
      telephone: PhoneNumberUtil.transformPhoneNumber(user.telephone),
      title: user.title,
      externalId: user.externalId ?? "-",
      jobTitle: user.jobTitle ?? "-",
      notify: user.notify,
      rolePom: user.rolePom ?? undefined,
      hasLogin: user.hasLogin,
    };
  }

  public static toTableRow(user: IUser, rowKey: number): IUserTableRow {
    return {
      rowKey,
      email: user.email,
      username: user.username,
      active: user.active,
      firstName: user.firstName,
      lastName: user.lastName,
      fullName: user.fullName,
      title: user.title,
      jobTitle: user.jobTitle ?? null,
      deliveryEmail: user.deliveryEmail,
      telephone: user.telephone,
      externalId: user.externalId,
      rolePom: user.rolePom ?? undefined,
      groupType: user.group?.type,
      erpNumber: user.group?.erpNumber ?? "",
      groupName: user.group?.name ?? "",
      hasLogin: user.hasLogin,
    };
  }
}
